export default "__VITE_ASSET__PVoTBNcY__"